/**
 * مسیر فایل‌های داخل `public/` وقتی اپ زیر زیرمسیر deploy می‌شود (package.json homepage).
 */
export function publicAssetPath(path: string): string {
  const base = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}
